import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getPayableMappingCategory } from "../../../../Bookclosure/Services/ApiHandler";

export default function Category({ PayableID, onMappingChange }) {
  const [fields, setFields] = useState([]);
  const [labels, setLabels] = useState([]);
  const [selectedMapping, setSelectedMapping] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategoryFields = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await getPayableMappingCategory(PayableID);
        console.log("Category API Response:", res.data);

        setFields(res.data.fields || []);
        setLabels(res.data.labelList || []);
      } catch (err) {
        console.error("Error fetching Category mapping:", err);
        setError("Failed to load Category mapping.");
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryFields();
  }, [PayableID]);

  const handleChange = (key, value) => {
    const updated = { ...selectedMapping, [key]: value };
    setSelectedMapping(updated);

    const arrayFormat = Object.entries(updated).map(([k, v]) => ({
      key: k,
      values: v,
    }));

    onMappingChange(arrayFormat);
  };

  if (loading) return <div className={styles.loadingText}>Loading Category mapping...</div>;
  if (error) return <div className={styles.errorText}>{error}</div>;

  return (

      <div className={styles.formGroup}>
        {fields.map((fieldKey, i) => (
          <CustomDropdown
            key={i}
            label={fieldKey}
            value={selectedMapping[fieldKey] || ""}
            onChange={(value) => handleChange(fieldKey, value)}
            options={labels}
            placeholder="Select Column"
          />
        ))}
      </div>
  
  );
}